import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.BankAccountsPage.BankAccountCard.CardControls', {
    areYouSure: 'Are you sure you want to remove "{nickname}" bank account?',
    delete: 'Remove',
    reconnectAccount: 'Reconnect account',
    changeNickname: 'Change nickname',
    removeAccount: 'Remove account',
    rematchXeroBankAccount: 'Rematch Xero bank account',
});
